import { ArrowLeft, Share2, Heart } from "lucide-react";
import { BrandLogo } from "@/components/shared/BrandLogo";
import { UnifiedStatusBadge } from "@/components/shared/UnifiedStatusBadge";
import { useOfferDetail } from "./OfferDetailContext";

export default function OfferHero() {
  const { offer, cc, vd, closesLabel, closesUrgent, confidence, dealStatus, isFavorited, toggleFavorite, setShowShare, navigate } = useOfferDetail();

  return (
    <>
      {/* 1. GRADIENT HEADER — category colored */}
      <div className={`${cc.gradient} text-white pt-12 pb-4 px-4 relative`} data-testid="detail-header">
        {/* Top action row */}
        <div className="absolute top-3 left-3 right-3 flex items-center gap-2">
          <button onClick={() => navigate(-1)} className="p-3 rounded-full bg-black/15 hover:bg-black/25 transition backdrop-blur-sm" data-testid="back-button"><ArrowLeft className="w-5 h-5" /></button>
          <div className="flex-1" />
          {dealStatus && <UnifiedStatusBadge status={dealStatus} />}
          <button onClick={() => setShowShare(true)} className="p-3 rounded-full bg-black/15 backdrop-blur-sm" data-testid="detail-share-btn"><Share2 className="w-5 h-5" /></button>
          <button onClick={toggleFavorite} className="p-3 rounded-full bg-black/15 backdrop-blur-sm" data-testid="detail-favorite-btn"><Heart className={`w-5 h-5 ${isFavorited ? "fill-red-400 text-red-400" : "text-white"}`} /></button>
        </div>
        {/* Avatar + Name + Category */}
        <div className="flex items-center gap-3 mt-2">
          <BrandLogo name={offer.name} logoUrl={offer.logo_url} size="lg" cuisineTag={offer.cuisine_tags?.[0] || offer.category} />
          <div className="flex-1 min-w-0">
            <h1 className="text-xl font-bold truncate leading-tight" data-testid="detail-title">{offer.name}</h1>
            <p className="text-white/75 text-sm">{offer.category}</p>
          </div>
        </div>
        {/* Offer name pill */}
        <div className="mt-3">
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-sm font-semibold px-3 py-1.5 rounded-lg leading-tight" data-testid="detail-offer-pill">
            {offer.offer_title || "Birthday deal"}
          </span>
        </div>
      </div>

      {/* 2. STATS BAR */}
      <div className="bg-white border-b border-slate-100 px-4 py-2.5 flex items-center justify-between text-[12px]" data-testid="detail-stats-bar">
        <div className="flex flex-col items-center">
          <span className="text-slate-400 font-medium">Worth</span>
          <span className={`font-bold ${cc.text}`}>{vd ? vd.value : "—"}</span>
        </div>
        <div className="w-px h-6 bg-slate-200" />
        <div className="flex flex-col items-center">
          <span className="text-slate-400 font-medium">Confidence</span>
          <span className={`font-bold ${cc.text}`}>{confidence > 0 ? `${confidence}%` : "—"}</span>
        </div>
        <div className="w-px h-6 bg-slate-200" />
        <div className="flex flex-col items-center">
          <span className="text-slate-400 font-medium">{offer.hours_status?.minutes_until_close != null ? "Closes In" : "Hours"}</span>
          <span className={`font-bold ${closesUrgent ? "text-amber-600" : cc.text}`}>{closesLabel}</span>
        </div>
      </div>
    </>
  );
}
